var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _linearGradient76, _linearGradient77, _linearGradient78, _linearGradient79, _linearGradient80, _linearGradient81, _linearGradient82, _linearGradient83, _linearGradient84, _linearGradient85, _linearGradient86, _linearGradient87, _linearGradient88, _linearGradient89, _linearGradient90, _linearGradient91, _linearGradient92, _linearGradient93, _linearGradient94, _linearGradient95, _linearGradient96, _linearGradient97, _linearGradient98, _linearGradient99, _linearGradient100, _linearGradient101, _linearGradient102, _linearGradient103, _linearGradient104, _linearGradient105, _linearGradient106, _linearGradient107, _linearGradient108, _linearGradient109, _linearGradient110, _circle, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _path2, _circle23, _path3, _circle24, _circle25, _circle26, _path4, _circle27, _path5, _circle28, _path6, _circle29, _circle30, _circle31, _circle32, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBonus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.302,
    x2: 398.435,
    xlinkHref: "#lg1",
    y1: 147.065,
    y2: 436.198
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.518,
    x2: 111.28,
    xlinkHref: "#lg2",
    y1: 302.281,
    y2: 149.043
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.271,
    x2: 502.246,
    xlinkHref: "#lg3",
    y1: 295.864,
    y2: 527.119
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.933,
    x2: 129.91,
    xlinkHref: "#lg1",
    y1: 399.696,
    y2: 167.673
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(-1 0 0 -1 510 -1618)",
    gradientUnits: "userSpaceOnUse",
    x1: 354.429,
    x2: 138.688,
    xlinkHref: "#lg1",
    y1: -1811.334,
    y2: -2027.075
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(0 1 1 0 1693.406 -1693.406)",
    gradientUnits: "userSpaceOnUse",
    x1: 2173.803,
    x2: 2146.838,
    xlinkHref: "#lg1",
    y1: -1431.834,
    y2: -1458.799
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.635,
    x2: 259.49,
    xlinkHref: "#lg4",
    y1: 469.46,
    y2: 478.316
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(0 1 1 0 1693.406 -1693.406)",
    gradientUnits: "userSpaceOnUse",
    x1: 1811.678,
    x2: 1784.713,
    xlinkHref: "#lg1",
    y1: -1431.834,
    y2: -1458.799
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.635,
    x2: 259.49,
    xlinkHref: "#lg4",
    y1: 107.335,
    y2: 116.19
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(-1 0 0 1 607.406 1161.406)",
    gradientUnits: "userSpaceOnUse",
    x1: 540.04,
    x2: 513.075,
    xlinkHref: "#lg1",
    y1: -862.071,
    y2: -889.036
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(0 1 -1 0 -1086 -532)",
    gradientUnits: "userSpaceOnUse",
    x1: 820.398,
    x2: 829.253,
    xlinkHref: "#lg4",
    y1: -1164.303,
    y2: -1155.447
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-1 0 0 1 607.406 1161.406)",
    gradientUnits: "userSpaceOnUse",
    x1: 177.915,
    x2: 150.95,
    xlinkHref: "#lg1",
    y1: -862.071,
    y2: -889.036
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(0 1 -1 0 -1086 -532)",
    gradientUnits: "userSpaceOnUse",
    x1: 820.398,
    x2: 829.253,
    xlinkHref: "#lg4",
    y1: -1526.428,
    y2: -1517.573
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-.707 .707 .707 .707 1741.651 -41.195)",
    gradientUnits: "userSpaceOnUse",
    x1: 1475.014,
    x2: 1448.049,
    xlinkHref: "#lg1",
    y1: -808.514,
    y2: -835.478
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -653.175 -41.195)",
    gradientUnits: "userSpaceOnUse",
    x1: 873.964,
    x2: 882.82,
    xlinkHref: "#lg4",
    y1: -229.338,
    y2: -220.482
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-.707 .707 .707 .707 1741.651 -41.195)",
    gradientUnits: "userSpaceOnUse",
    x1: 1112.885,
    x2: 1085.92,
    xlinkHref: "#lg1",
    y1: -808.514,
    y2: -835.478
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -653.175 -41.195)",
    gradientUnits: "userSpaceOnUse",
    x1: 873.964,
    x2: 882.82,
    xlinkHref: "#lg4",
    y1: -591.467,
    y2: -582.611
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-.707 -.707 -.707 .707 -1044.805 1209.651)",
    gradientUnits: "userSpaceOnUse",
    x1: -83.13,
    x2: -110.094,
    xlinkHref: "#lg1",
    y1: -1560.882,
    y2: -1587.847
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -1044.805 -1185.175)",
    gradientUnits: "userSpaceOnUse",
    x1: 121.595,
    x2: 130.451,
    xlinkHref: "#lg4",
    y1: -1787.481,
    y2: -1778.625
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(-.707 -.707 -.707 .707 -1044.805 1209.651)",
    gradientUnits: "userSpaceOnUse",
    x1: -445.259,
    x2: -472.223,
    xlinkHref: "#lg1",
    y1: -1560.882,
    y2: -1587.847
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -1044.805 -1185.175)",
    gradientUnits: "userSpaceOnUse",
    x1: 121.595,
    x2: 130.451,
    xlinkHref: "#lg4",
    y1: -2149.61,
    y2: -2140.754
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(-.379 .925 .925 .379 1882.231 -879.838)",
    gradientUnits: "userSpaceOnUse",
    x1: 1889.764,
    x2: 1862.8,
    xlinkHref: "#lg1",
    y1: -1054.295,
    y2: -1081.259
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(.925 .379 -.379 .925 -326.98 44.697)",
    gradientUnits: "userSpaceOnUse",
    x1: 628.193,
    x2: 637.049,
    xlinkHref: "#lg4",
    y1: 185.484,
    y2: 194.339
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-.379 .925 .925 .379 1882.231 -879.838)",
    gradientUnits: "userSpaceOnUse",
    x1: 1527.647,
    x2: 1500.683,
    xlinkHref: "#lg1",
    y1: -1054.278,
    y2: -1081.242
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(.925 .379 -.379 .925 -326.98 44.697)",
    gradientUnits: "userSpaceOnUse",
    x1: 628.21,
    x2: 637.065,
    xlinkHref: "#lg4",
    y1: -176.633,
    y2: -167.778
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-.925 -.379 -.379 .925 -206.162 1350.231)",
    gradientUnits: "userSpaceOnUse",
    x1: 162.015,
    x2: 135.052,
    xlinkHref: "#lg1",
    y1: -1146.775,
    y2: -1173.739
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(-.379 .925 -.925 -.379 -1130.697 -858.98)",
    gradientUnits: "userSpaceOnUse",
    x1: 535.713,
    x2: 544.569,
    xlinkHref: "#lg4",
    y1: -1542.265,
    y2: -1533.409
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(-.925 -.379 -.379 .925 -206.162 1350.231)",
    gradientUnits: "userSpaceOnUse",
    x1: -200.101,
    x2: -227.065,
    xlinkHref: "#lg1",
    y1: -1146.759,
    y2: -1173.722
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(-.379 .925 -.925 -.379 -1130.697 -858.98)",
    gradientUnits: "userSpaceOnUse",
    x1: 535.73,
    x2: 544.585,
    xlinkHref: "#lg4",
    y1: -1904.381,
    y2: -1895.526
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-.923 .386 .386 .923 1299.128 667.154)",
    gradientUnits: "userSpaceOnUse",
    x1: 1006.326,
    x2: 979.361,
    xlinkHref: "#lg1",
    y1: -741.83,
    y2: -768.795
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientTransform: "matrix(.386 .923 -.923 .386 -916.707 -241.321)",
    gradientUnits: "userSpaceOnUse",
    x1: 940.609,
    x2: 949.465,
    xlinkHref: "#lg4",
    y1: -698.045,
    y2: -689.189
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(-.923 .386 .386 .923 1299.128 667.154)",
    gradientUnits: "userSpaceOnUse",
    x1: 644.201,
    x2: 617.236,
    xlinkHref: "#lg1",
    y1: -741.842,
    y2: -768.806
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(.386 .923 -.923 .386 -916.707 -241.321)",
    gradientUnits: "userSpaceOnUse",
    x1: 940.598,
    x2: 949.453,
    xlinkHref: "#lg4",
    y1: -1060.17,
    y2: -1051.314
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientTransform: "matrix(-.386 -.923 -.923 .386 -1753.154 767.128)",
    gradientUnits: "userSpaceOnUse",
    x1: -149.911,
    x2: -176.875,
    xlinkHref: "#lg1",
    y1: -2029.045,
    y2: -2056.01
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(-.923 .386 -.386 -.923 -844.68 -1448.707)",
    gradientUnits: "userSpaceOnUse",
    x1: -346.606,
    x2: -337.75,
    xlinkHref: "#lg4",
    y1: -1854.281,
    y2: -1845.425
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(-.386 -.923 -.923 .386 -1753.154 767.128)",
    gradientUnits: "userSpaceOnUse",
    x1: -512.036,
    x2: -539,
    xlinkHref: "#lg1",
    y1: -2029.057,
    y2: -2056.021
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(-.923 .386 -.386 -.923 -844.68 -1448.707)",
    gradientUnits: "userSpaceOnUse",
    x1: -346.617,
    x2: -337.762,
    xlinkHref: "#lg4",
    y1: -2216.406,
    y2: -2207.551
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.359,
    x2: 46.436,
    y1: 326.329,
    y2: -110.531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.959,
    x2: 126.111,
    xlinkHref: "#lg3",
    y1: 260.273,
    y2: 176.132
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.509,
    x2: 262.778,
    xlinkHref: "#lg3",
    y1: 231.548,
    y2: 121.405
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb27e"
  }))), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.412,
    x2: 358.136,
    xlinkHref: "#lg5",
    y1: 85.042,
    y2: 228.766
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb27e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.168,
    x2: 284.45,
    xlinkHref: "#lg6",
    y1: 92.583,
    y2: 184.617
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.81,
    x2: 254.917,
    xlinkHref: "#lg2",
    y1: 154.807,
    y2: 154.807
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.898,
    x2: 341.88,
    xlinkHref: "#lg3",
    y1: 126.83,
    y2: 240.594
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.064,
    x2: 312.806,
    xlinkHref: "#lg3",
    y1: 157.042,
    y2: 152.568
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.037,
    x2: 265.803,
    xlinkHref: "#lg2",
    y1: 209.304,
    y2: 61.667
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.001,
    x2: 224.814,
    xlinkHref: "#lg5",
    y1: 83.037,
    y2: 168.68
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.364,
    x2: 166.653,
    xlinkHref: "#lg3",
    y1: 81.881,
    y2: 33.308
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.087,
    x2: 299.36,
    xlinkHref: "#lg6",
    y1: 41.602,
    y2: 149.614
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.581,
    x2: 196.983,
    xlinkHref: "#lg2",
    y1: 82.422,
    y2: 186.6
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.448,
    x2: 334.352,
    xlinkHref: "#lg3",
    y1: 124.761,
    y2: 7.162
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.771,
    x2: 202.343,
    xlinkHref: "#lg2",
    y1: 124.735,
    y2: 74.144
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.086,
    x2: 206.585,
    xlinkHref: "#lg5",
    y1: 143.759,
    y2: 250.988
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.237,
    x2: 151.61,
    xlinkHref: "#lg6",
    y1: 149.385,
    y2: 218.05
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.478,
    x2: 129.576,
    xlinkHref: "#lg2",
    y1: 195.809,
    y2: 195.809
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.117,
    x2: 194.457,
    xlinkHref: "#lg3",
    y1: 174.936,
    y2: 259.813
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.968,
    x2: 172.766,
    xlinkHref: "#lg3",
    y1: 197.477,
    y2: 194.139
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.493,
    x2: 137.698,
    xlinkHref: "#lg2",
    y1: 236.468,
    y2: 126.32
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.335,
    x2: 107.117,
    xlinkHref: "#lg5",
    y1: 142.264,
    y2: 206.159
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.276,
    x2: 63.724,
    xlinkHref: "#lg3",
    y1: 141.401,
    y2: 105.161
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.528,
    x2: 162.734,
    xlinkHref: "#lg6",
    y1: 111.35,
    y2: 191.935
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.09,
    x2: 86.353,
    xlinkHref: "#lg2",
    y1: 141.805,
    y2: 219.529
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.323,
    x2: 188.84,
    xlinkHref: "#lg3",
    y1: 173.392,
    y2: 85.655
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.451,
    x2: 90.352,
    xlinkHref: "#lg2",
    y1: 173.373,
    y2: 135.629
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.211,
    x2: 371.184,
    xlinkHref: "#lg3",
    y1: 271.759,
    y2: 204.405
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.811,
    x2: 457.31,
    xlinkHref: "#lg5",
    y1: 143.759,
    y2: 250.988
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.961,
    x2: 402.334,
    xlinkHref: "#lg6",
    y1: 149.385,
    y2: 218.05
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.202,
    x2: 380.3,
    xlinkHref: "#lg2",
    y1: 195.809,
    y2: 195.809
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.841,
    x2: 445.181,
    xlinkHref: "#lg3",
    y1: 174.936,
    y2: 259.813
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.693,
    x2: 423.49,
    xlinkHref: "#lg3",
    y1: 197.477,
    y2: 194.139
  })), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 413.217,
    x2: 388.422,
    xlinkHref: "#lg2",
    y1: 236.468,
    y2: 126.32
  })), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.059,
    x2: 357.841,
    xlinkHref: "#lg5",
    y1: 142.264,
    y2: 206.159
  })), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 406,
    x2: 314.448,
    xlinkHref: "#lg3",
    y1: 141.401,
    y2: 105.161
  })), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.252,
    x2: 413.458,
    xlinkHref: "#lg6",
    y1: 111.35,
    y2: 191.935
  })), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.815,
    x2: 337.077,
    xlinkHref: "#lg2",
    y1: 141.805,
    y2: 219.529
  })), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.047,
    x2: 439.565,
    xlinkHref: "#lg3",
    y1: 173.392,
    y2: 85.655
  })), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.176,
    x2: 341.076,
    xlinkHref: "#lg2",
    y1: 173.373,
    y2: 135.629
  })), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.201,
    x2: 198.857,
    xlinkHref: "#lg5",
    y1: 427.615,
    y2: 349.27
  })), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b302"
  }))), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.4,
    x2: 274.62,
    xlinkHref: "#lg7",
    y1: 395.126,
    y2: 420.254
  })), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffed82"
  }))), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.097,
    x2: 245.23,
    xlinkHref: "#lg8",
    y1: 410.079,
    y2: 394.04
  })), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005a01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005a01"
  }))), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.087,
    x2: 233.028,
    xlinkHref: "#lg9",
    y1: 405.361,
    y2: 366.071
  })), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.336,
    x2: 241.915,
    xlinkHref: "#lg9",
    y1: 413.116,
    y2: 384.668
  })), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.853,
    x2: 148.281,
    xlinkHref: "#lg5",
    y1: 403.854,
    y2: 332.282
  })), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.353,
    x2: 219.435,
    xlinkHref: "#lg7",
    y1: 381.756,
    y2: 399.971
  })), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.045,
    x2: 198.692,
    xlinkHref: "#lg8",
    y1: 391.538,
    y2: 376.335
  })), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.725,
    x2: 189.283,
    xlinkHref: "#lg9",
    y1: 389.175,
    y2: 360.693
  })), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.355,
    x2: 195.726,
    xlinkHref: "#lg9",
    y1: 394.797,
    y2: 374.174
  })), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.379,
    x2: 273.76,
    xlinkHref: "#lg5",
    y1: 404.804,
    y2: 358.185
  })), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.93,
    x2: 319.011,
    xlinkHref: "#lg7",
    y1: 381.756,
    y2: 399.971
  })), _linearGradient99 || (_linearGradient99 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.293,
    x2: 297.266,
    xlinkHref: "#lg8",
    y1: 393.365,
    y2: 379.833
  })), _linearGradient100 || (_linearGradient100 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.302,
    x2: 288.86,
    xlinkHref: "#lg9",
    y1: 389.175,
    y2: 360.693
  })), _linearGradient101 || (_linearGradient101 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.931,
    x2: 295.303,
    xlinkHref: "#lg9",
    y1: 394.797,
    y2: 374.174
  })), _linearGradient102 || (_linearGradient102 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 401.32,
    y2: 353.893
  })), _linearGradient103 || (_linearGradient103 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg10"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2cbff"
  }))), _linearGradient104 || (_linearGradient104 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.523,
    x2: 288.363,
    xlinkHref: "#lg10",
    y1: 229.412,
    y2: 425.771
  })), _linearGradient105 || (_linearGradient105 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg10",
    y1: 357.047,
    y2: 191.997
  })), _linearGradient106 || (_linearGradient106 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.074,
    x2: 117.074,
    xlinkHref: "#lg4",
    y1: 355.8,
    y2: 456.801
  })), _linearGradient107 || (_linearGradient107 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.682,
    x2: 201.682,
    xlinkHref: "#lg4",
    y1: 322.292,
    y2: 423.293
  })), _linearGradient108 || (_linearGradient108 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.073,
    x2: 288.073,
    xlinkHref: "#lg4",
    y1: 288.078,
    y2: 389.079
  })), _linearGradient109 || (_linearGradient109 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.527,
    x2: 379.527,
    xlinkHref: "#lg4",
    y1: 251.859,
    y2: 352.859
  })), _linearGradient110 || (_linearGradient110 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.956,
    x2: 456.956,
    xlinkHref: "#lg4",
    y1: 221.194,
    y2: 322.194
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 292.763,
    fill: "url(#SVGID_1_)",
    r: 196.577
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 292.763,
    fill: "url(#SVGID_2_)",
    r: 185.213
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m255 96.186c-108.567 0-196.577 88.011-196.577 196.577s88.01 196.577 196.577 196.577 196.577-88.011 196.577-196.577-88.01-196.577-196.577-196.577zm0 381.79c-102.29 0-185.213-82.922-185.213-185.213s82.923-185.213 185.213-185.213 185.213 82.923 185.213 185.213-82.923 185.213-185.213 185.213z",
    fill: "url(#SVGID_3_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 292.763,
    fill: "url(#SVGID_4_)",
    r: 165.085
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 292.763,
    fill: "url(#SVGID_5_)",
    r: 153.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 473.826,
    fill: "url(#SVGID_6_)",
    r: 11.678
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 473.826,
    fill: "url(#SVGID_7_)",
    r: 10.075
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 111.7,
    fill: "url(#SVGID_8_)",
    r: 11.678
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 111.7,
    fill: "url(#SVGID_9_)",
    r: 10.075
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.937,
    cy: 292.763,
    fill: "url(#SVGID_10_)",
    r: 11.678
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.937,
    cy: 292.763,
    fill: "url(#SVGID_11_)",
    r: 10.075
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.063,
    cy: 292.763,
    fill: "url(#SVGID_12_)",
    r: 11.678
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.063,
    cy: 292.763,
    fill: "url(#SVGID_13_)",
    r: 10.075
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.969,
    cy: 420.794,
    fill: "url(#SVGID_14_)",
    r: 11.678
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.969,
    cy: 420.794,
    fill: "url(#SVGID_15_)",
    r: 10.075
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.031,
    cy: 164.732,
    fill: "url(#SVGID_16_)",
    r: 11.678
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.031,
    cy: 164.732,
    fill: "url(#SVGID_17_)",
    r: 10.075
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.969,
    cy: 164.732,
    fill: "url(#SVGID_18_)",
    r: 11.678
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.969,
    cy: 164.732,
    fill: "url(#SVGID_19_)",
    r: 10.075
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.031,
    cy: 420.794,
    fill: "url(#SVGID_20_)",
    r: 11.678
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 383.031,
    cy: 420.794,
    fill: "url(#SVGID_21_)",
    r: 10.075
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.317,
    cy: 460.293,
    fill: "url(#SVGID_22_)",
    r: 11.678
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.317,
    cy: 460.293,
    fill: "url(#SVGID_23_)",
    r: 10.075
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m319.253 136.038c5.968 2.447 12.789-.408 15.235-6.376 2.447-5.968-.408-12.789-6.375-15.235-5.968-2.447-12.789.408-15.235 6.375-2.447 5.969.407 12.79 6.375 15.236z",
    fill: "url(#SVGID_24_)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.683,
    cy: 125.233,
    fill: "url(#SVGID_25_)",
    r: 10.075
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m76.664 219.65c-2.447 5.968.408 12.789 6.375 15.235 5.968 2.447 12.789-.408 15.235-6.375 2.447-5.968-.408-12.789-6.375-15.235-5.967-2.447-12.788.407-15.235 6.375z",
    fill: "url(#SVGID_26_)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.47,
    cy: 224.08,
    fill: "url(#SVGID_27_)",
    r: 10.075
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.53,
    cy: 361.446,
    fill: "url(#SVGID_28_)",
    r: 11.678
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.53,
    cy: 361.446,
    fill: "url(#SVGID_29_)",
    r: 10.075
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m77.199 367.167c2.49 5.95 9.331 8.755 15.281 6.265s8.755-9.331 6.265-15.281-9.331-8.755-15.281-6.265c-5.95 2.489-8.755 9.331-6.265 15.281z",
    fill: "url(#SVGID_30_)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.972,
    cy: 362.658,
    fill: "url(#SVGID_31_)",
    r: 10.075
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m411.255 227.376c2.49 5.95 9.331 8.755 15.281 6.265s8.755-9.331 6.265-15.281-9.331-8.755-15.281-6.265c-5.95 2.489-8.755 9.331-6.265 15.281z",
    fill: "url(#SVGID_32_)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.028,
    cy: 222.868,
    fill: "url(#SVGID_33_)",
    r: 10.075
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m180.596 114.962c-5.95 2.49-8.755 9.331-6.265 15.281s9.331 8.755 15.281 6.265 8.755-9.331 6.265-15.281c-2.489-5.95-9.331-8.755-15.281-6.265z",
    fill: "url(#SVGID_34_)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.105,
    cy: 125.735,
    fill: "url(#SVGID_35_)",
    r: 10.075
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.895,
    cy: 459.791,
    fill: "url(#SVGID_36_)",
    r: 11.678
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.895,
    cy: 459.791,
    fill: "url(#SVGID_37_)",
    r: 10.075
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 292.763,
    fill: "url(#SVGID_38_)",
    r: 184.635
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m317.714 265.292c-.476-1.03-1.3-1.904-2.405-2.405-.476-1.031-1.3-1.904-2.405-2.405l-115.428-115.429c-.656-1.421-1.974-2.547-3.776-2.804l-37.617-5.409c-30.976 19.693-55.679 48.365-70.462 82.351l-.067.389c-.345 1.989.513 3.757 1.909 4.8l64.929 64.929c.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.753.877 1.403 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.272.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.403 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.349.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.272.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.349.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.753.877 1.403 1.529 1.89.271.203.568.37.876.515.35.752.877 1.402 1.529 1.89.271.203.568.37.876.515.35.752.877 1.403 1.529 1.89 1.406 1.052 3.359 1.379 5.18.468l36.995-18.44 36.995 18.44c1.821.91 3.775.583 5.18-.468 1.397-1.043 2.254-2.811 1.909-4.8l-6.957-40.584 29.649-28.261c1.494-1.423 1.839-3.403 1.291-5.1-.415-1.285-1.332-2.399-2.64-2.992z",
    fill: "url(#SVGID_39_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m438.232 269.957c-4.777-38.774-21.567-73.828-46.543-101.316-4.723-4.665-9.242-9.141-13.468-13.366-.002-.002-.004-.003-.005-.005-8.08-7.246-16.804-13.788-26.072-19.535-.142-.088-.282-.177-.424-.264-.992-.612-1.993-1.211-2.998-1.805-.223-.131-.444-.264-.668-.395-.955-.558-1.917-1.107-2.882-1.648-.28-.157-.56-.315-.841-.47-.932-.516-1.869-1.024-2.811-1.525-.319-.17-.639-.338-.959-.506-.922-.483-1.849-.96-2.78-1.428-.343-.172-.686-.342-1.03-.512-.922-.456-1.847-.907-2.778-1.348-.355-.168-.712-.333-1.069-.499-.931-.434-1.864-.864-2.803-1.283-.354-.158-.711-.311-1.067-.467-.95-.417-1.902-.831-2.861-1.232-.331-.139-.666-.271-.998-.408-.992-.408-1.985-.814-2.985-1.205-.241-.094-.484-.183-.725-.276-3.592-1.387-7.237-2.668-10.934-3.833-.108-.034-.214-.071-.322-.104-.888-.278-1.784-.54-2.678-.805-.514-.152-1.025-.311-1.541-.458-.803-.23-1.611-.447-2.419-.666-.613-.167-1.224-.337-1.839-.498-.767-.2-1.539-.389-2.31-.579-.664-.164-1.326-.329-1.993-.486-.746-.176-1.496-.342-2.246-.508-.699-.155-1.397-.31-2.099-.457-.731-.153-1.465-.299-2.199-.444-.73-.144-1.46-.285-2.193-.42-.718-.132-1.437-.26-2.157-.384-.755-.13-1.512-.255-2.271-.376-.709-.113-1.419-.223-2.13-.328-.778-.115-1.559-.222-2.34-.327-.698-.094-1.396-.187-2.096-.272-.806-.099-1.616-.189-2.425-.277-.683-.075-1.365-.151-2.05-.218-.841-.082-1.685-.153-2.529-.224-.659-.056-1.318-.115-1.979-.163-.892-.065-1.788-.117-2.683-.17-.62-.036-1.239-.079-1.861-.109-1-.049-2.003-.082-3.007-.114-.522-.017-1.041-.043-1.564-.055-1.507-.037-3.017-.057-4.533-.057-.022 0-.045-.001-.067-.001-.013 0-.025 0-.038 0-1.487 0-2.969.021-4.448.056-.495.012-.986.034-1.48.049-.998.032-1.995.066-2.99.114-.579.028-1.156.063-1.734.096-.908.052-1.816.107-2.72.173-.603.043-1.205.091-1.806.14-.882.072-1.762.15-2.64.234-.601.058-1.202.116-1.801.18-.891.094-1.779.198-2.667.305-.574.069-1.148.136-1.721.21-.956.124-1.909.261-2.861.4-.494.072-.989.138-1.481.214-1.424.22-2.844.453-4.257.705-.189.034-.376.073-.565.107-1.234.224-2.465.458-3.69.707-.527.107-1.05.223-1.575.335-.886.188-1.772.377-2.653.578-.587.134-1.172.275-1.757.414-.817.194-1.633.392-2.446.597-.602.152-1.203.308-1.803.466-.794.209-1.587.424-2.377.643-.6.167-1.199.334-1.797.507-.796.23-1.588.468-2.379.708-.578.176-1.158.349-1.734.53-.848.267-1.692.545-2.535.823-.508.168-1.018.33-1.523.502-1.311.446-2.617.904-3.914 1.379-.005.002-.01.004-.015.005l13.621 13.004-9.302 54.358c-.462 2.666.687 5.036 2.559 6.434l76.857 76.857h162.904z",
    fill: "url(#SVGID_40_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m346.232 87.556c-.723-2.263-2.63-4.147-5.367-4.538l-55.32-8.045-24.573-50.569c-1.209-2.488-3.59-3.744-5.972-3.744s-4.763 1.256-5.972 3.744l-24.574 50.569-55.32 8.045c-2.737.391-4.645 2.275-5.367 4.538-.735 2.275-.273 4.929 1.73 6.837l39.739 37.879-9.325 54.396c-.462 2.666.687 5.036 2.559 6.434 1.884 1.41 4.502 1.848 6.943.628l49.587-24.717 49.585 24.716c2.441 1.22 5.059.782 6.943-.628 1.872-1.398 3.021-3.768 2.559-6.434l-9.325-54.396 39.739-37.879c2.004-1.907 2.466-4.562 1.731-6.836zm-91.232 28.933-.083.024.036-.036.047-.071.047.071.035.036z",
    fill: "url(#SVGID_41_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m254.953 116.478-.036.036-49.68 15.758-39.739-37.879c-2.002-1.908-2.464-4.562-1.73-6.837z",
    fill: "url(#SVGID_42_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m254.917 116.513-56.446 76.588c-1.872-1.398-3.021-3.768-2.559-6.434l9.325-54.396z",
    fill: "url(#SVGID_43_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m311.529 193.101c-1.884 1.41-4.502 1.848-6.943.628l-49.586-24.716v-52.524l.083.024z",
    fill: "url(#SVGID_44_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m255 116.489v52.524l-49.585 24.716c-2.441 1.22-5.059.782-6.943-.628l56.446-76.588z",
    fill: "url(#SVGID_45_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m311.529 193.101-56.446-76.588 49.68 15.758 9.325 54.396c.462 2.666-.687 5.036-2.559 6.434z",
    fill: "url(#SVGID_46_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m255 116.406-.047.071-91.185-28.922c.723-2.263 2.63-4.147 5.367-4.538l55.32-8.045z",
    fill: "url(#SVGID_47_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m285.545 74.973-30.545 41.433v-95.746c2.381 0 4.763 1.256 5.972 3.744z",
    fill: "url(#SVGID_48_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m255 20.66v95.747l-30.545-41.434 24.574-50.569c1.208-2.488 3.589-3.744 5.971-3.744z",
    fill: "url(#SVGID_49_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m346.232 87.556-91.185 28.922-.047-.072 30.545-41.434 55.32 8.045c2.737.392 4.645 2.276 5.367 4.539z",
    fill: "url(#SVGID_50_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m344.503 94.392-39.739 37.879-49.68-15.758-.035-.036 91.185-28.922c.733 2.275.271 4.93-1.731 6.837z",
    fill: "url(#SVGID_51_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m330.781 90.942c-.6-1.88-2.185-3.445-4.458-3.769l-45.951-6.683-20.412-42.004c-1.004-2.067-2.982-3.11-4.96-3.11s-3.956 1.043-4.96 3.11l-20.412 42.004-45.951 6.683c-2.273.325-3.858 1.89-4.458 3.769-.61 1.89-.226 4.094 1.437 5.679l33.009 31.464-7.745 45.183c-.384 2.214.571 4.183 2.126 5.344 1.565 1.171 3.74 1.535 5.767.522l41.187-20.53 41.188 20.53c2.027 1.014 4.202.65 5.767-.522 1.555-1.161 2.51-3.13 2.126-5.344l-7.745-45.183 33.009-31.464c1.663-1.585 2.046-3.789 1.436-5.679zm-75.781 24.033-.069.02.03-.03.039-.059.039.059.03.03z",
    fill: "url(#SVGID_52_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m197.704 145.635c-.539-1.688-1.962-3.094-4.004-3.386l-41.273-6.002-18.334-37.728c-.902-1.856-2.678-2.794-4.455-2.794s-3.554.937-4.455 2.794l-18.334 37.728-41.273 6.002c-2.042.292-3.465 1.697-4.004 3.386-.548 1.697-.203 3.677 1.291 5.101l29.649 28.261-6.957 40.583c-.345 1.989.513 3.757 1.909 4.8 1.406 1.052 3.359 1.379 5.18.469l36.995-18.44 36.995 18.44c1.821.91 3.775.583 5.18-.469 1.397-1.043 2.254-2.811 1.909-4.8l-6.957-40.583 29.649-28.261c1.493-1.424 1.837-3.404 1.289-5.101zm-68.066 21.586-.062.018.026-.027.035-.053.035.053.027.027z",
    fill: "url(#SVGID_53_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m129.602 167.212-.026.027-37.065 11.757-29.649-28.261c-1.494-1.423-1.839-3.403-1.291-5.101z",
    fill: "url(#SVGID_54_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m129.576 167.239-42.113 57.14c-1.397-1.043-2.254-2.811-1.909-4.8l6.957-40.583z",
    fill: "url(#SVGID_55_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m171.813 224.38c-1.406 1.052-3.359 1.379-5.18.469l-36.995-18.44v-39.187l.062.018z",
    fill: "url(#SVGID_56_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m129.638 167.221v39.187l-36.995 18.44c-1.821.91-3.775.583-5.18-.469l42.113-57.14z",
    fill: "url(#SVGID_57_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m171.813 224.38-42.113-57.14 37.065 11.757 6.957 40.583c.345 1.988-.513 3.756-1.909 4.8z",
    fill: "url(#SVGID_58_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m129.638 167.16-.035.053-68.031-21.578c.539-1.688 1.962-3.094 4.004-3.386l41.273-6.002z",
    fill: "url(#SVGID_59_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m152.427 136.247-22.789 30.913v-71.435c1.777 0 3.554.937 4.455 2.794z",
    fill: "url(#SVGID_60_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m129.638 95.725v71.435l-22.789-30.913 18.334-37.728c.901-1.857 2.678-2.794 4.455-2.794z",
    fill: "url(#SVGID_61_)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m197.704 145.635-68.031 21.578-.035-.053 22.789-30.913 41.273 6.002c2.042.292 3.465 1.697 4.004 3.386z",
    fill: "url(#SVGID_62_)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m196.414 150.735-29.649 28.261-37.065-11.757-.027-.027 68.031-21.578c.548 1.698.204 3.678-1.29 5.101z",
    fill: "url(#SVGID_63_)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m186.176 148.161c-.448-1.402-1.63-2.57-3.326-2.812l-34.283-4.986-15.229-31.339c-.749-1.542-2.225-2.32-3.701-2.32s-2.952.778-3.701 2.32l-15.229 31.339-34.283 4.986c-1.696.242-2.878 1.41-3.326 2.812-.455 1.41-.169 3.055 1.072 4.237l24.627 23.475-5.779 33.71c-.286 1.652.426 3.121 1.586 3.987 1.167.874 2.79 1.145 4.303.389l30.729-15.317 30.729 15.317c1.513.756 3.135.485 4.303-.389 1.16-.866 1.872-2.335 1.586-3.987l-5.779-33.71 24.627-23.475c1.243-1.182 1.53-2.827 1.074-4.237zm-56.538 17.931-.051.015.022-.022.029-.044.029.044.022.022z",
    fill: "url(#SVGID_64_)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m333.001 169.322 10.162 9.702-6.94 40.556c-.345 1.989.513 3.757 1.909 4.8l57.341 57.341 8.809-12.96c3.5-5.149 8.374-9.223 14.087-11.699 5.585-2.42 10.892-5.359 15.865-8.752-8.326-33.682-25.894-63.715-49.863-87.261-1.35-.039-2.704-.066-4.064-.066-16.62.001-32.553 2.945-47.306 8.339z",
    fill: "url(#SVGID_65_)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m448.429 145.635c-.539-1.688-1.962-3.094-4.004-3.386l-41.273-6.002-18.334-37.728c-.902-1.856-2.679-2.794-4.455-2.794s-3.554.937-4.455 2.794l-18.334 37.728-41.273 6.002c-2.042.292-3.465 1.697-4.004 3.386-.548 1.697-.203 3.677 1.291 5.101l29.649 28.261-6.957 40.583c-.345 1.989.513 3.757 1.909 4.8 1.406 1.052 3.359 1.379 5.18.469l36.994-18.44 36.995 18.44c1.821.91 3.775.583 5.18-.469 1.397-1.043 2.254-2.811 1.909-4.8l-6.957-40.583 29.649-28.261c1.493-1.424 1.838-3.404 1.29-5.101zm-68.067 21.586-.062.018.027-.027.035-.053.035.053.027.027z",
    fill: "url(#SVGID_66_)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m380.327 167.212-.027.027-37.065 11.757-29.649-28.261c-1.494-1.423-1.839-3.403-1.291-5.101z",
    fill: "url(#SVGID_67_)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m380.3 167.239-42.113 57.14c-1.397-1.043-2.254-2.811-1.909-4.8l6.957-40.583z",
    fill: "url(#SVGID_68_)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m422.537 224.38c-1.406 1.052-3.359 1.379-5.18.469l-36.995-18.44v-39.187l.062.018z",
    fill: "url(#SVGID_69_)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m380.362 167.221v39.187l-36.994 18.44c-1.821.91-3.775.583-5.18-.469l42.113-57.14z",
    fill: "url(#SVGID_70_)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m422.537 224.38-42.113-57.14 37.065 11.757 6.957 40.583c.345 1.988-.512 3.756-1.909 4.8z",
    fill: "url(#SVGID_71_)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m380.362 167.16-.035.053-68.031-21.578c.539-1.688 1.962-3.094 4.004-3.386l41.273-6.002z",
    fill: "url(#SVGID_72_)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m403.151 136.247-22.789 30.913v-71.435c1.777 0 3.554.937 4.455 2.794z",
    fill: "url(#SVGID_73_)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m380.362 95.725v71.435l-22.789-30.913 18.334-37.728c.902-1.857 2.678-2.794 4.455-2.794z",
    fill: "url(#SVGID_74_)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m448.429 145.635-68.031 21.578-.035-.053 22.789-30.913 41.273 6.002c2.041.292 3.464 1.697 4.004 3.386z",
    fill: "url(#SVGID_75_)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m447.138 150.735-29.649 28.261-37.065-11.757-.027-.027 68.031-21.578c.549 1.698.204 3.678-1.29 5.101z",
    fill: "url(#SVGID_76_)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m436.901 148.161c-.448-1.402-1.63-2.57-3.326-2.812l-34.283-4.986-15.229-31.339c-.749-1.542-2.225-2.32-3.701-2.32s-2.952.778-3.701 2.32l-15.229 31.339-34.283 4.986c-1.696.242-2.878 1.41-3.326 2.812-.455 1.41-.169 3.055 1.072 4.237l24.627 23.475-5.779 33.71c-.286 1.652.426 3.121 1.586 3.987 1.168.874 2.79 1.145 4.303.389l30.729-15.317 30.729 15.317c1.513.756 3.135.485 4.303-.389 1.16-.866 1.872-2.335 1.586-3.987l-5.779-33.71 24.627-23.475c1.243-1.182 1.529-2.827 1.074-4.237zm-56.539 17.931-.051.015.022-.022.029-.044.029.044.022.022z",
    fill: "url(#SVGID_77_)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m250.854 369.284-23.013 33.261c-1.194 1.726-1.194 4.011 0 5.737l23.013 33.261c2.005 2.897 6.287 2.897 8.291 0l23.013-33.261c1.194-1.726 1.194-4.011 0-5.737l-23.013-33.261c-2.004-2.897-6.286-2.897-8.291 0z",
    fill: "url(#SVGID_78_)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m251.369 373.769-20.156 29.132c-1.046 1.512-1.046 3.513 0 5.025l20.156 29.132c1.756 2.538 5.506 2.538 7.262 0l20.156-29.132c1.046-1.512 1.046-3.513 0-5.025l-20.156-29.132c-1.756-2.538-5.506-2.538-7.262 0z",
    fill: "url(#SVGID_79_)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m260.641 376.673c-1.456-2.105-4.578-2.382-6.215-.414-.085.102-.167.21-.245.322l-18.757 27.109c-1.888 2.729-1.888 6.342 0 9.071l17.895 25.864c1.827.748 4.069.23 5.312-1.567l20.157-29.132c1.046-1.512 1.046-3.513 0-5.025z",
    fill: "url(#SVGID_80_)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m258.631 373.769c-1.001-1.446-2.65-2.065-4.208-1.862v67.014c1.558.203 3.207-.416 4.208-1.863l20.156-29.132c1.046-1.512 1.046-3.513 0-5.025z",
    fill: "url(#SVGID_81_)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m251.369 437.057c1.756 2.538 5.506 2.538 7.262 0l20.156-29.132c.523-.756.784-1.634.784-2.512h-49.144c0 .878.262 1.757.785 2.512z",
    fill: "url(#SVGID_82_)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m202.206 363.021-16.683 24.112c-.866 1.251-.866 2.908 0 4.159l16.683 24.112c1.453 2.1 4.558 2.1 6.011 0l16.683-24.112c.866-1.251.866-2.908 0-4.159l-16.683-24.112c-1.453-2.1-4.558-2.1-6.011 0z",
    fill: "url(#SVGID_83_)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m202.579 366.273-14.612 21.119c-.758 1.096-.758 2.547 0 3.642l14.612 21.119c1.273 1.84 3.992 1.84 5.264 0l14.612-21.119c.758-1.096.758-2.547 0-3.642l-14.612-21.119c-1.272-1.84-3.991-1.84-5.264 0z",
    fill: "url(#SVGID_84_)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m209.301 368.378c-1.056-1.526-3.319-1.727-4.506-.301-.062.074-.121.152-.177.233l-13.597 19.652c-1.369 1.978-1.369 4.598 0 6.576l12.973 18.75c1.325.542 2.949.167 3.85-1.136l14.612-21.119c.758-1.096.758-2.547 0-3.643z",
    fill: "url(#SVGID_85_)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m207.844 366.273c-.725-1.049-1.921-1.497-3.051-1.35v48.581c1.13.147 2.325-.302 3.051-1.35l14.612-21.119c.758-1.096.758-2.547 0-3.642z",
    fill: "url(#SVGID_86_)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m202.579 412.153c1.273 1.84 3.992 1.84 5.264 0l14.612-21.119c.379-.548.569-1.185.569-1.821h-35.626c0 .637.189 1.273.569 1.821z",
    fill: "url(#SVGID_87_)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m301.783 363.021-16.683 24.112c-.866 1.251-.866 2.908 0 4.159l16.683 24.112c1.453 2.1 4.558 2.1 6.011 0l16.683-24.112c.866-1.251.866-2.908 0-4.159l-16.683-24.112c-1.453-2.1-4.558-2.1-6.011 0z",
    fill: "url(#SVGID_88_)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m302.156 366.273-14.612 21.119c-.758 1.096-.758 2.547 0 3.642l14.612 21.119c1.273 1.84 3.992 1.84 5.264 0l14.612-21.119c.758-1.096.758-2.547 0-3.642l-14.612-21.119c-1.272-1.84-3.991-1.84-5.264 0z",
    fill: "url(#SVGID_89_)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m308.877 368.378c-1.056-1.526-3.319-1.727-4.506-.301-.062.074-.121.152-.177.233l-13.597 19.652c-1.369 1.978-1.369 4.598 0 6.576l12.973 18.75c1.324.542 2.949.167 3.85-1.136l14.612-21.119c.758-1.096.758-2.547 0-3.643z",
    fill: "url(#SVGID_90_)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m307.421 366.273c-.726-1.049-1.921-1.497-3.051-1.35v48.581c1.13.147 2.325-.302 3.051-1.35l14.612-21.119c.758-1.096.758-2.547 0-3.642z",
    fill: "url(#SVGID_91_)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m302.156 412.153c1.273 1.84 3.992 1.84 5.264 0l14.612-21.119c.379-.548.569-1.185.569-1.821h-35.626c0 .637.19 1.273.569 1.821z",
    fill: "url(#SVGID_92_)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m67.703 352.581c25.31 79.314 99.59 136.759 187.297 136.759s161.987-57.445 187.297-136.759z",
    fill: "url(#SVGID_93_)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m503.939 302.235c-3.393-6.64-7.685-12.197-12.793-16.569 4.199-2.484 7.785-6.123 10.469-10.75 3.582-6.18 5.398-12.574 5.398-19.003 0-8.768-3.731-16.846-10.519-22.757-4.86-4.227-10.863-7.245-17.849-8.97-4.832-1.192-9.155-1.985-13.215-2.426-3.846-.417-7.604-.629-11.172-.629-15.797 0-29.708 4.131-41.35 12.279-.364.255-.731.521-1.099.794-2.38-3.178-5.52-5.869-9.314-7.85-5.378-2.805-11.519-4.226-18.251-4.226-6.906 0-13.128 1.451-18.502 4.315-4.412 2.356-7.942 5.685-10.375 9.642-2.477-4.007-6.087-7.369-10.612-9.731-5.38-2.804-11.519-4.225-18.249-4.225-6.908 0-13.131 1.451-18.502 4.315-1.12.597-2.181 1.258-3.184 1.976-1.057-.751-2.177-1.444-3.365-2.064-5.379-2.805-11.519-4.226-18.252-4.226-6.736 0-12.878 1.423-18.256 4.229-4.334 2.261-7.831 5.445-10.295 9.236-2.845-3.734-5.809-6.469-9.111-8.467-5.569-3.364-12.516-4.998-21.237-4.998-6.854 0-13.096 1.503-18.552 4.47-4.189 2.278-7.567 5.432-9.975 9.148-10.952-9.029-25.011-13.618-41.818-13.618-17.042 0-31.283 4.765-42.323 14.16-1.265 1.076-2.45 2.219-3.583 3.403-8.971-11.308-23.726-17.563-43.022-17.563h-34.01c-6.84 0-13.039 1.707-18.427 5.074-8.004 5.002-12.594 13.249-12.594 22.625v105.521c0 8.37 3.873 15.906 10.887 21.207 5.542 4.199 12.316 6.329 20.134 6.329h36.832c15.34 0 28.079-4.69 37.863-13.936.854-.807 1.659-1.657 2.442-2.527 1.103 1.145 2.251 2.252 3.478 3.295 11.045 9.399 25.285 14.164 42.325 14.164 17.021 0 31.228-4.701 42.242-13.963 2.374 3.436 5.602 6.353 9.542 8.491 5.456 2.97 11.702 4.476 18.562 4.476 6.854 0 13.095-1.504 18.55-4.469 4.446-2.416 7.99-5.81 10.418-9.825 4.396 6.325 13.248 14.294 29.931 14.294 6.855 0 13.097-1.504 18.552-4.471 4.169-2.266 7.534-5.401 9.94-9.094.205.176.397.362.605.535 11.182 9.307 25.674 14.025 43.073 14.025 17.261 0 31.706-4.703 42.934-13.979.741-.613 1.496-1.278 2.254-1.992 2.832 2.601 6.311 5.134 10.592 7.511 10.892 6.054 23.551 9.122 37.627 9.122 17.07 0 31.423-4.743 42.66-14.098 12.14-10.106 18.557-24.563 18.557-41.807 0-9.644-2.038-18.525-6.061-26.403z",
    fill: "url(#SVGID_94_)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m448.783 372.702c-12.039 0-22.763-2.568-31.873-7.631-3.241-1.799-6.045-3.778-8.336-5.882l-.971-.891c-4.022-3.694-10.214-3.657-14.192.084l-.961.903c-.56.526-1.129 1.029-1.69 1.493-9.043 7.471-20.95 11.262-35.385 11.262-14.519 0-26.436-3.776-35.426-11.225 0 0-.371-.333-.539-.478l-1.229-1.055c-4.782-4.105-12.084-3.061-15.524 2.219l-.884 1.357c-1.385 2.127-3.293 3.861-5.672 5.152-3.702 2.014-8.04 3.034-12.897 3.034-9.16 0-15.959-3.099-20.206-9.21l-1.248-1.796c-4.309-6.2-13.574-5.905-17.481.556l-1.131 1.871c-1.366 2.26-3.42 4.178-5.939 5.548-3.701 2.011-8.039 3.031-12.894 3.031-4.859 0-9.2-1.022-12.9-3.035-2.264-1.229-4.097-2.849-5.459-4.821l-.887-1.283c-3.494-5.057-10.581-6.009-15.286-2.053l-1.194 1.004c-8.826 7.421-20.473 11.184-34.62 11.184-14.15 0-25.808-3.816-34.65-11.34-.832-.708-1.689-1.522-2.622-2.491l-1.057-1.098c-4.198-4.36-11.214-4.24-15.261.26l-1.019 1.133c-.678.754-1.24 1.338-1.769 1.837-7.62 7.202-17.345 10.702-29.73 10.702h-36.83c-5.249 0-9.495-1.284-12.981-3.925-4.058-3.067-6.196-7.133-6.196-11.768v-105.521c0-5.282 2.496-9.751 7.029-12.585 3.475-2.171 7.563-3.273 12.149-3.273h34.013c10.66 0 25.167 2.269 33.744 13.08l1.011 1.274c3.928 4.952 11.324 5.296 15.696.731l1.125-1.175c.948-.991 1.833-1.832 2.704-2.574 8.84-7.522 20.497-11.336 34.648-11.336 13.966 0 25.501 3.671 34.285 10.913l1.227 1.012c4.806 3.962 11.991 2.853 15.379-2.374l.866-1.335c1.387-2.14 3.302-3.884 5.693-5.183 3.701-2.012 8.04-3.032 12.896-3.032 6.502 0 11.446 1.077 15.114 3.292 2.046 1.238 3.896 2.99 5.814 5.507l1.221 1.602c4.37 5.736 13.104 5.409 17.033-.637l1.097-1.689c1.398-2.15 3.363-3.896 5.842-5.189 3.671-1.916 7.97-2.887 12.779-2.887 4.807 0 9.105.971 12.776 2.885.668.349 1.335.758 1.978 1.215l.824.586c3.626 2.578 8.488 2.571 12.106-.018l.227-.162c1.012-.724 2.06-1.406 3.18-1.951 3.484-1.696 7.588-2.555 12.211-2.555 4.804 0 9.102.971 12.775 2.885 2.546 1.329 4.627 3.217 6.01 5.456l1.21 1.958c4.08 6.6 13.683 6.589 17.747-.021l1.205-1.96c1.358-2.208 3.386-4.075 5.865-5.398 3.633-1.936 7.983-2.919 12.925-2.919 4.807 0 9.105.971 12.774 2.884 2.156 1.126 3.944 2.623 5.31 4.447l.846 1.13c3.438 4.592 9.94 5.544 14.55 2.129l1.134-.84c.283-.209.565-.414.843-.61 9.609-6.725 21.236-10.136 34.556-10.136 3.14 0 6.469.189 9.894.56 3.531.384 7.344 1.087 11.656 2.15 5.138 1.269 9.484 3.425 12.913 6.408 4.217 3.671 6.448 8.452 6.448 13.821 0 4.318-1.279 8.713-3.801 13.063-1.639 2.826-3.743 5.013-6.252 6.496l-1.707 1.01c-6.15 3.638-6.9 12.245-1.471 16.892l1.507 1.289c3.923 3.358 7.269 7.718 9.948 12.96 3.16 6.19 4.764 13.26 4.764 21.014 0 13.807-4.808 24.812-14.291 32.708-9.055 7.533-20.858 11.355-35.086 11.355z",
    fill: "url(#SVGID_95_)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m19.739 355.35v-105.522c0-2.543 1.104-4.505 3.318-5.889 2.211-1.382 4.866-2.073 7.963-2.073h34.013c22.12 0 33.183 9.846 33.183 29.532 0 13.273-4.703 21.958-14.103 26.048 5.641 2.102 9.898 5.118 12.776 9.042 2.875 3.927 4.314 9.764 4.314 17.504v3.484c0 12.389-3.015 21.431-9.042 27.126-6.029 5.699-14.131 8.546-24.306 8.546h-36.834c-3.429 0-6.167-.773-8.212-2.323-2.049-1.548-3.07-3.373-3.07-5.475zm25.717-67.859h17.421c2.986 0 5.309-1.133 6.968-3.4 1.659-2.266 2.488-4.95 2.488-8.048 0-3.095-.829-5.807-2.488-8.13-1.659-2.322-3.982-3.484-6.968-3.484h-17.421zm0 53.092h16.591c8.848 0 13.273-5.086 13.273-15.264v-2.655c0-10.176-4.425-15.264-13.273-15.264h-16.591z",
    fill: "url(#SVGID_96_)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m113.312 324.988v-43.967c0-13.494 3.704-23.394 11.116-29.699 7.409-6.305 17.256-9.457 29.533-9.457 12.387 0 22.287 3.152 29.698 9.457 7.409 6.305 11.116 16.205 11.116 29.699v43.967c0 13.495-3.707 23.394-11.116 29.698-7.412 6.304-17.311 9.457-29.698 9.457-12.277 0-22.123-3.153-29.533-9.457-7.411-6.304-11.116-16.203-11.116-29.698zm25.882 0c0 11.061 4.92 16.591 14.766 16.591 9.955 0 14.933-5.53 14.933-16.591v-43.967c0-11.059-4.977-16.592-14.933-16.592-9.846 0-14.766 5.533-14.766 16.592z",
    fill: "url(#SVGID_97_)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m211.366 355.184v-105.356c0-2.543 1.27-4.505 3.816-5.889 2.543-1.382 5.584-2.073 9.125-2.073 4.978 0 8.654.72 11.033 2.156 2.377 1.439 5.06 5.035 8.047 10.785l26.878 51.267v-56.41c0-2.544 1.27-4.479 3.816-5.807 2.543-1.328 5.584-1.991 9.125-1.991 3.538 0 6.579.663 9.125 1.991 2.543 1.328 3.816 3.263 3.816 5.807v105.521c0 2.546-1.273 4.508-3.816 5.89-2.546 1.384-5.587 2.074-9.125 2.074-7.08 0-11.891-2.323-14.435-6.969l-31.523-57.406v56.41c0 2.546-1.272 4.508-3.816 5.89-2.546 1.384-5.586 2.074-9.125 2.074-3.541 0-6.582-.69-9.125-2.074-2.546-1.382-3.816-3.345-3.816-5.89z",
    fill: "url(#SVGID_98_)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m313.567 324.988v-75.325c0-2.544 1.244-4.479 3.733-5.807s5.559-1.991 9.208-1.991c3.539 0 6.579.663 9.125 1.991 2.544 1.328 3.816 3.263 3.816 5.807v75.325c0 11.061 5.309 16.591 15.928 16.591 10.618 0 15.928-5.53 15.928-16.591v-75.325c0-2.544 1.244-4.479 3.733-5.807s5.559-1.991 9.209-1.991c3.538 0 6.579.663 9.125 1.991 2.543 1.328 3.816 3.263 3.816 5.807v75.325c0 13.495-3.816 23.394-11.448 29.698s-17.752 9.457-30.362 9.457c-12.721 0-22.87-3.153-30.445-9.457-7.58-6.304-11.366-16.203-11.366-29.698z",
    fill: "url(#SVGID_99_)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m408.798 343.238c0-3.095 1.133-6.193 3.402-9.291 2.266-3.095 4.894-4.645 7.881-4.645 1.659 0 3.51.671 5.558 2.012 2.045 1.342 3.925 2.828 5.641 4.459 1.714 1.633 4.119 3.119 7.217 4.459 3.095 1.342 6.359 2.012 9.789 2.012 4.314 0 8.072-.913 11.282-2.737 3.207-1.825 4.811-4.563 4.811-8.213 0-3.651-1.799-6.857-5.392-9.623-3.595-2.764-7.964-5.281-13.107-7.549-5.144-2.266-10.316-4.811-15.513-7.632-5.2-2.82-9.597-6.828-13.19-12.028-3.596-5.198-5.392-11.391-5.392-18.582 0-11.725 4.147-20.49 12.443-26.298 8.296-5.807 18.305-8.71 30.03-8.71 2.875 0 5.89.171 9.042.513 3.152.343 6.691.998 10.618 1.968 3.925.969 7.134 2.535 9.624 4.7 2.488 2.167 3.733 4.788 3.733 7.863 0 2.923-.913 5.957-2.737 9.104-1.825 3.147-4.343 4.72-7.549 4.72-1.327 0-4.148-1.05-8.461-3.152-4.314-2.1-9.071-3.152-14.269-3.152-5.533 0-9.68.969-12.443 2.903-2.766 1.936-4.148 4.288-4.148 7.052 0 2.545 1.299 4.868 3.9 6.967 2.597 2.103 5.833 3.9 9.705 5.393 3.87 1.493 8.101 3.43 12.693 5.807 4.588 2.38 8.819 4.978 12.692 7.798 3.87 2.821 7.105 6.777 9.705 11.863 2.598 5.089 3.899 10.895 3.899 17.421 0 11.406-3.816 20.285-11.448 26.64-7.632 6.354-17.644 9.529-30.03 9.529-10.73 0-20.075-2.211-28.039-6.637-7.965-4.425-11.947-9.402-11.947-14.934z",
    fill: "url(#SVGID_100_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBonus);
export default __webpack_public_path__ + "static/media/icon-bonus.30a2f9564d174edcfd341aebea7a0f2d.svg";
export { ForwardRef as ReactComponent };